import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgCombineChecksSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.25 4.403v3.224h2.821c.574 0 1.126.223 1.536.625.41.403.643.952.643 1.527V21a.75.75 0 0 1-1.15.634L17 20.31l-2.1 1.325a.75.75 0 0 1-.8 0L12 20.31l-2.1 1.325A.75.75 0 0 1 8.75 21v-4.963L7 14.932l-2.1 1.326a.75.75 0 0 1-1.15-.635V4.403c0-.576.233-1.125.643-1.527.41-.402.962-.626 1.536-.626h7.142c.574 0 1.126.224 1.536.626.41.402.643.951.643 1.527ZM8.886 9.029H7a.75.75 0 0 0 0 1.5h1.75v-.75c0-.259.047-.512.136-.75Zm2.043.098h2.821v5.136l-1.35-.852a.75.75 0 0 0-.8 0l-1.35.852V9.78a.64.64 0 0 1 .194-.456.692.692 0 0 1 .485-.196Zm3.161 7.125a.747.747 0 0 0 .408.121H17a.75.75 0 0 0 0-1.5h-1.75v.75a.75.75 0 0 1-.75.75h-.002a.75.75 0 0 1-.398-.115l-.01-.006Zm1.16-3.502H17a.75.75 0 0 0 0-1.5h-1.75v1.5ZM6.25 6A.75.75 0 0 1 7 5.25h5a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 6Z",
  fill: "currentColor"
})));

export { SvgCombineChecksSolid as default };
